export * from './room.types';
export { PATIENT_ROOM_FEATURE_KEYS } from './patientRoomFeatureKeys';
export {
  // Re-export types from generated file
  type GetRoomsForUserQuery,
  type GetRoomsForUserQueryVariables,
  type UpdateRoomMutation,
  type UpdateRoomMutationVariables,
  // Re-export query hooks from generated file
  useLazyGetRoomsForUserQuery,
  useLazyIsSlugUniqueQuery,
  useLazyIsSubSlugUniqueQuery,
  useGetRoomForPatientQuery,
  useLazyGetRoomForPatientQuery,
  useIsValidPasscodeForRoomMutation,
  useNotifyMembersAboutPatientMutation,
  useSubmitPersonalRoomToOgMutation,
  useIsUsingNativeRoomsQuery,
  // Export the API
  api as roomApi,
} from './operations.generated';
// Re-export enhanced hooks with header support
export { useGetRoomsForUserQuery } from './operations.enhanced';
// Export enhanced hooks with cache update logic
export {
  useUpdateRoomMutation as useUpdateRoomMutationGraphql,
  useGetRoomsForTenantQuery,
  useRemoveRoomMemberMutation,
  useAddRoomMembersMutation,
  useDeleteSharedRoomMutation,
  useCreateSharedRoomMutation,
} from './room.api';
